import {
    AgencySettingsInput,
    MessageOverageSettingsInput,
    OverageSettingsInput,
    UpdateInput,
} from './input/update-input'
import { del, get, patch, post, toQueryString } from '../axios'
import { CompanyQuery, company, companyUsage } from './company'
import { companyUser } from './company-user'
import { CompanyRole } from './company-role'
import { z } from 'zod'
import { column } from '../campaign/column'
import { paginated } from '../zod/pagination'

export function fetchCompanies({ query }: { query?: CompanyQuery } = {}) {
    return get(paginated(company), '/companies' + `?${toQueryString(query || {})}`)
}

export function fetchCompany(companyId: string) {
    return get(company, `/companies/${companyId}`)
}

export function fetchCompanyUsage(companyId: string) {
    return get(companyUsage, `/companies/${companyId}/usage`)
}

export function fetchCompanyUsers(companyId: string) {
    return get(companyUser.array(), `/companies/${companyId}/users`)
}

export function deleteCompanyUser(companyId: string, userId: string) {
    return del(z.string(), `/companies/${companyId}/users/${userId}`)
}

export function updateCompanyUserRole(companyId: string, userId: string, role: CompanyRole) {
    return patch(z.string(), `/companies/${companyId}/users/${userId}/role`, { role })
}

export function updateCompany(companyId: string, input: UpdateInput) {
    return patch(company, `/companies/${companyId}`, input)
}

export function updateCompanyOverageSettings(companyId: string, input: OverageSettingsInput) {
    return patch(company, `/companies/${companyId}/overage-settings`, input)
}

export function updateCompanyMessageOverageSettings(companyId: string, input: MessageOverageSettingsInput) {
    return patch(company, `/companies/${companyId}/message-overage-settings`, input)
}

export function updateCompanyAgencySettings(companyId: string, input: AgencySettingsInput) {
    return patch(company, `/admin/companies/${companyId}/agency-settings`, input)
}

export function startCompanyTrial(companyId: string) {
    return post(z.unknown(), `/companies/${companyId}/start-trial`, {})
}

export function reorderCompanyColumn(companyId: string, order: string[]) {
    return patch(column.array(), `/companies/${companyId}/columns/reorder`, { order })
}

export function storeCompanyColumn(companyId: string, input: { name: string }) {
    return post(column, `/companies/${companyId}/columns`, input)
}

export function updateCompanyColumn(companyId: string, columnId: string, name: string) {
    return patch(column, `/companies/${companyId}/columns/${columnId}`, { name })
}

export function deleteCompanyColumn(companyId: string, columnId: string) {
    return del(column, `/companies/${companyId}/columns/${columnId}`)
}

export function sortCompanyColumnCandidates(companyId: string, columnId: string) {
    return (input: { sortBy: string; direction: string }) =>
        patch(z.string(), `/companies/${companyId}/columns/${columnId}/sort`, input)
}
